import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import useApp from "../../hooks/useApp";
import "./styles.scss";
import RightTickIcon from "../RightTick";
import { getSessionStorage } from "../../utils/storageUtils";
import { STORAGE_KEYS } from "../../constants";
import CurrencyText from "../CurrencyText";

const getResponsiveFontSize = (baseSize) => {
  if (!baseSize) return undefined;
  return `clamp(${Math.max(baseSize - 8, 12)}px, ${
    baseSize / 18
  }rem + 1vw, ${baseSize}px)`;
};

export const DefaultHeading = ({
  style,
  heading,
  description,
  phoneNumber,
  containerClassNames,
  leftIcon,
  descriptionLeftIcon,
  highgLightBtnAmount,
  expiresIn,
  amount,
  descriptionData,
  hasSpinner,
  phoneNo = null,
  specialText,
  headingStyle = {},
  specialTextStyle = {},
  descriptionStyle = {},
  iconVariant,
  iconColor,
  rightIconContainerStyle = {},
  highgLightBtnAmountStyle = {},
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];
  const { tenantConfig, userDetails, isRTL, selectedLanguage } = useApp();
  const descriptionParseData = descriptionData
    ? JSON.parse(descriptionData)
    : "";

  const handleDescription = (description) => {
    const partnerTenantName = getSessionStorage(
      STORAGE_KEYS.PARTNER_TENANT_NAME
    );
    if (
      t(`${routeName}.${description}`).includes("\\n") ||
      t(`${description}`).includes("\\n")
    ) {
      return t(routeName ? `${routeName}.${description}` : description)
        .split("\\n")
        .map((line, index) => (
          <div className="description-container" key={index}>
            <div
              className="right-icon-container"
              style={rightIconContainerStyle}
            >
              <RightTickIcon iconVariant={iconVariant} iconColor={iconColor} />
            </div>
            <span className="description-with-icon" style={descriptionStyle}>
              {line.trim()}
            </span>
          </div>
        ));
    } else {
      return (
        <div className="single-description-container">
          {descriptionLeftIcon && (
            <img
              src={descriptionLeftIcon}
              alt={descriptionLeftIcon}
              className="description-left-icon"
            />
          )}
          <p
            className="screen-description"
            style={{
              whiteSpace: "pre-line",
              fontSize: getResponsiveFontSize(style?.descriptionFontSize),
              textAlign: style?.centerAlign ? "center" : "-webkit-match-parent",
              color: style?.color,
              ...descriptionStyle,
            }}
          >
            {routeName
              ? t(`${routeName}.${description}`, {
                  tenant: tenantConfig?.name,
                  otpCount: tenantConfig?.otp_setting?.content?.length,
                  contactNo: userDetails?.contact_no,
                  partnerTenantName:
                    partnerTenantName &&
                    partnerTenantName[selectedLanguage?.value],
                  phoneNo: "\n+966 283 3892",
                  expiresIn: expiresIn > 0 ? expiresIn : "",
                  businessDays: descriptionParseData,
                  phoneNumber: phoneNo,
                })
              : t(`${description}`, {
                  tenant: tenantConfig?.name,
                  otpCount: tenantConfig?.otp_setting?.content.length,
                  contactNo: userDetails?.contact_no,
                  partnerTenantName:
                    partnerTenantName &&
                    partnerTenantName[selectedLanguage?.value],
                  businessDays: descriptionParseData,
                  phoneNumber: phoneNo,
                })}
          </p>
        </div>
      );
    }
  };

  return (
    <div
      className={
        style?.centerAlign
          ? `mt-4 ${style?.backgroundColor}`
          : `d-flex ${style?.backgroundColor}`
      }
      style={{
        ...(style?.marginBottom !== undefined && {
          marginBottom: `${style.marginBottom}px`,
        }),
        ...(style?.marginTop !== undefined && {
          marginTop: `${style.marginTop}px`,
        }),
        ...(style?.backgroundColor && {
          backgroundColor: style?.backgroundColor,
          paddingTop: 10,
          borderRadius: 10,
          marginRight: 20,
          marginLeft: 20,
        }),
      }}
    >
      <div className={`screen-heading ${containerClassNames}`}>
        {hasSpinner ? (
          <div className={`spinner ${style?.centerAlign && "mx-auto"}`} />
        ) : null}
        <div
          className="screen-title-row"
          style={{
            justifyContent: style?.centerAlign ? "center" : "flex-start",
          }}
        >
          {leftIcon && (
            <img src={leftIcon} alt={leftIcon} className="left-icon" />
          )}
          {heading && (
            <p
              className={`screen-title ${isRTL ? "screen-title-rtl" : ""}`}
              style={{
                fontSize: getResponsiveFontSize(style?.headingFontSize),
                textAlign: style?.centerAlign
                  ? "center"
                  : "-webkit-match-parent",
                color: style?.color,
                ...headingStyle,
              }}
            >
              {routeName
                ? t(`${routeName}.${heading}`, {
                    tenant: tenantConfig?.name,
                    customerName: userDetails?.first_name,
                  })
                : t(`${heading}`, {
                    tenant: tenantConfig?.name,
                    customerName: userDetails?.first_name,
                  })}
              {specialText ? (
                <span style={specialTextStyle}>
                  {" "}
                  {routeName
                    ? t(`${routeName}.${specialText}`)
                    : t(`${specialText}`)}
                </span>
              ) : null}
            </p>
          )}
        </div>
        {description && handleDescription(description)}
        {!!highgLightBtnAmount && (
          <div
            className="hight-light-btn"
            style={{
              fontSize: getResponsiveFontSize(style?.highlightFontSize || 16),
              ...highgLightBtnAmountStyle,
            }}
          >
            {<CurrencyText value={amount?.value} />}
          </div>
        )}
        {phoneNumber && (
          <p dir="ltr" className="screen-phone-number">
            {phoneNumber}
          </p>
        )}
      </div>
    </div>
  );
};
